export default __webpack_public_path__ + "static/media/18.bbceb86e.jpg";